import { render } from "./ReportMemberPurchases.vue?vue&type=template&id=6fac7aee&scoped=true"
import script from "./ReportMemberPurchases.vue?vue&type=script&lang=js"
export * from "./ReportMemberPurchases.vue?vue&type=script&lang=js"

import "./ReportMemberPurchases.vue?vue&type=style&index=0&id=6fac7aee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fac7aee"]])

export default __exports__